<create-login-background></create-login-background>
<div *ngIf="!_.expired" class="container">
  <form
    *ngIf="!_.submitted"
    class="rv-grid large"
    (ngSubmit)="_.doSubmit()"
    #changePasswordForm="ngForm"
    [ngFormOptions]="{ updateOn: 'submit' }"
    [class.submitted]="changePasswordForm.submitted"
  >
    <h5 class="title">Create your account</h5>
    <riv-text-field
      class="email"
      name="email"
      label="Email"
      type="email"
      [value]="_.email"
      [disabled]="true"
    ></riv-text-field>

    <div class="rv-rows medium fill">
      <div>
        <riv-text-field
          autocomplete="new-password"
          name="password"
          label="Password"
          [type]="_.showPassword ? 'text' : 'password'"
          [required]="true"
          (keydown)="_.setClientSideError('')"
          [(value)]="password"
          (valueChange)="_.checkForm()"
          [placeholder]="'Enter your password'"
          [state]="
            _.clientSideError.length > 0 || _.clientSideRepeatError.length > 0
              ? 'error'
              : 'valid'
          "
        ></riv-text-field>
      </div>
      <div>
        <riv-text-field
          autocomplete="repeat-new-password"
          name="repeat-password"
          label="Confirm password"
          [value]="_.repeatPassword"
          (valueChange)="_.setRepeatPassword($event); _.checkForm()"
          [required]="true"
          [type]="_.showPassword ? 'text' : 'password'"
          (keydown)="_.setClientSideRepeatError('')"
          [placeholder]="'Enter your password'"
          [state]="
            _.clientSideError.length > 0 || _.clientSideRepeatError.length > 0
              ? 'error'
              : 'valid'
          "
        ></riv-text-field>
      </div>
      <riv-checkbox
        identifier="show-password"
        class="show-password"
        [class.error]="!!_.submittingError"
        [value]="_.showPassword"
        (valueChange)="_.setShowPassword(!_.showPassword)"
      >
        Show password
      </riv-checkbox>
      <p class="password-requirement">
        {{ passwordRequirementsText }}
      </p>
    </div>

    <submit-error *ngIf="_.submittingError">
      <span>{{ _.submittingError }}</span>
      <a class="rv-link" *ngIf="_.resend" (click)="_.doResend()">
        {{ _.resendLoad.loading ? 'Resending link...' : 'Resend link' }}
      </a>
    </submit-error>
    <submit-error *ngIf="_.clientSideError.length > 0">
      {{ _.clientSideError }}
    </submit-error>
    <submit-error *ngIf="_.clientSideRepeatError.length > 0">
      {{ _.clientSideRepeatError }}
    </submit-error>

    <div class="rv-flex">
      <button
        rivButton
        class="primary"
        [disabled]="_.submitLoad.loading || !_.canSubmit"
        type="submit"
        [size]="'xlarge'"
      >
        {{ _.submitLoad.loading ? 'Creating account...' : 'Create account' }}
      </button>
    </div>
    <div class="rv-body-medium rv-low-contrast help">
      Need help? <a class="rv-link" (click)="openIntercom()">Contact support</a>
    </div>
  </form>
  <div *ngIf="_.submitted" class="rv-grid large">
    <h2 class="title">Your account has been created!</h2>
    <p class="confirmation">Log in with your new password.</p>
    <div class="rv-flex">
      <button
        rivButton
        class="primary"
        [size]="'xlarge'"
        routerLink="/login/password"
        [queryParams]="{ email: _.email }"
      >
        Go to login
      </button>
    </div>
    <div class="rv-body-medium rv-low-contrast help">
      Need help? <a class="rv-link" (click)="openIntercom()">Contact support</a>
    </div>
  </div>
</div>
<div *ngIf="_.expired" class="container expired">
  <h5 class="title">This link has expired.</h5>
  <p class="confirmation">
    Please contact your administrator for a new account activation link.
  </p>
  <div class="rv-body-medium rv-low-contrast help">
    Need help? <a class="rv-link" (click)="openIntercom()">Contact support</a>
  </div>
</div>
